/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetDeliveryScheduleColumnsForOrder(orderId) {
  const response = await $.soap({
    body: {
      GetDeliveryScheduleColumnsForOrder: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetDeliveryScheduleColumnsForOrderResponse.Columns.LU_DeliveryScheduleColumns'],
    blueprint: {
      deliveryScheduleColumns: [
        'GetDeliveryScheduleColumnsForOrderResponse.Columns.LU_DeliveryScheduleColumns',
        {
          id: '$..ID',
          name: '$..Code',
          label: '$..UILabel',
          width: '$..Width',
          downloadableBy: '$..DownloadableBy',
          renderableBy: '$..RenderableBy'
        }
      ]
    }
  });

  _.each(response.deliveryScheduleColumns, (res) => {
    res.label = res.label.replace(/\\n/g, '\n');
  });

  cleanUpResponse(response);
  return response.deliveryScheduleColumns;
}
